import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { StoreContext } from '../../models/store/context';

/**
 * @description Gets the appliance category name from the store based on the selected category code in the form data. Returns undefined if the category code is not found or if the form data is incomplete.
 * @param {StoreContext} state - The current store context containing the form data and catalogue information
 * @returns {string | undefined} The name of the appliance category corresponding to the selected category code in the form, or undefined if not found
 * @example
 *
 * // Assuming the form has a selected category code of 'WASH' and the catalogue contains a category with code 'WASH' and name 'Washing Machines', this function will return 'Washing Machines'.
 *
 * ````typescript
 * const categoryName = getFormCategoryName(store.getState());
 * console.log(categoryName); // Output: 'Washing Machines'
 * ````
 */
export const getFormCategoryName = (state: StoreContext): string | undefined => {
  try {
    const formCategoryCode = state.form?.[StepKey.APPLIANCE_DETAILS]?.[FormKey.SUPER_CATEGORY];
    return state.app.catalogue?.find((cat) => cat.categoryCode === formCategoryCode)?.categoryName;
  } catch (e) {
    console.error('Error selecting category name from store', e);
    return undefined;
  }
};
